import { createAsyncThunk } from "@reduxjs/toolkit";
import { handleError } from ".";
import WasteCategoryService from "../../services/wasteCategoryService";
import { startLoad, stopLoad } from "../loadingActions";

export const getCategory = createAsyncThunk(
  "category/get",
  async (_, { dispatch }) => {
    dispatch(startLoad());
    try {
      const res = await WasteCategoryService.getCategory();
      console.log(res)
      return res;
    } catch (err) {
      handleError(err, dispatch);
    } finally {
      // stop loading eventually
      dispatch(stopLoad());
    }
  }
);
export const getSubCategory = createAsyncThunk(
  "category/get_sub_categories",
  async (data, { dispatch }) => {
    dispatch(startLoad());
    try {
      const res = await WasteCategoryService.getSubCategory(data);
      return res;
    } catch (err) {
      handleError(err, dispatch);
    } finally {
      // stop loading eventually
      dispatch(stopLoad());
    }
  }
);

export const createCategory = createAsyncThunk(
  "category/add",
  async (data, { dispatch }) => {
    dispatch(startLoad());
    try {
      const res = await WasteCategoryService.createCategory(data);
      return res;
    } catch (err) {
      handleError(err, dispatch);
    } finally {
      // stop loading eventually
      dispatch(stopLoad());
    }
  }
);
export const createSubCategory = createAsyncThunk(
  "subcategory/add",
  async (data, { dispatch }) => {
    dispatch(startLoad());
    try {
      const res = await WasteCategoryService.createSubCategory(data);
      return res;
    } catch (err) {
      handleError(err, dispatch);
    } finally {
      // stop loading eventually
      dispatch(stopLoad());
    }
  }
);


// UPDATE CATEGORIES
export const updateCategory = createAsyncThunk(
  "category/update",
  async (data, { dispatch }) => {
    dispatch(startLoad());
    try {
      const { id, categoryData } = data;
      const res = await WasteCategoryService.updateCategory(id, categoryData);
      return res;
    } catch (err) {
      handleError(err, dispatch);
    } finally {
      // stop loading eventually
      dispatch(stopLoad());
    }
  }
);

// UPDATE SUBCATEGORIES
export const updateSubCategory = createAsyncThunk(
  "subcategory/update",
  async (data, { dispatch }) => {
    dispatch(startLoad());
    try {
      const { id, categoryData } = data;
      const res = await WasteCategoryService.updateSubCategory(id, categoryData);
      return res;
    } catch (err) {
      handleError(err, dispatch);
    } finally {
      // stop loading eventually
      dispatch(stopLoad());
    }
  }
);

// DELETE CATEGORY

export const deleteCategory = createAsyncThunk(
  "category/delete",
  async (data, { dispatch }) => {
    dispatch(startLoad());
    try {
      const res = await WasteCategoryService.deleteCategory(data);
      return res;
    } catch (err) {
      handleError(err, dispatch);
    } finally {
      // stop loading eventually
      dispatch(stopLoad());
    }
  }
);
export const deleteSubCategory = createAsyncThunk(
  "subcategory/delete",
  async (data, { dispatch }) => {
    dispatch(startLoad());
    try {
      const res = await WasteCategoryService.deleteSubCategory(data);
      return res;
    } catch (err) {
      handleError(err, dispatch);
    } finally {
      // stop loading eventually
      dispatch(stopLoad());
    }
  }
);
